import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { HomeDataService } from "./pages/home/home.service";
import { BlogDetailDataService } from "./pages/blog-detail/blog-detail.service";
import { BlogListingDataService } from "./pages/blog-listing/blog-listing.service";
import { CompetitionDetailDataService } from "./pages/competition-detail/competition-detail.service";
import { CompetitionsListingDataService } from "./pages/competitions-listing/competitions-listing.service";
import { EventsDetailDataService } from "./pages/events-detail/events-detail.service";
import { EventsListingDataService } from "./pages/events-listing/events-listing.service";
import { MovieDetailDataService } from "./pages/movie-detail/movie-detail.service";
import { MoviesListingDataService } from "./pages/movies-listing/movies-listing.service";
import { OffersDetailDataService } from "./pages/offers-detail/offers-detail.service";
import { OffersListingDataService } from "./pages/offers-listing/offers-listing.service";
import { PageDetailDataService } from "./pages/page-detail/page-detail.service";
import { ProfileDataService } from "./pages/auth/profile/profile.service";
import { StoreDetailDataService } from "./pages/store-detail/store-detail.service";
import { StoresListingDataService } from "./pages/stores-listing/stores-listing.service";
import { MallMapsGuard } from "./pages/mall-map/mall-map.guard";

const APP_ROUTES: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/home/home.module").then((m) => m.HomePageModule),
    resolve: {
      data: HomeDataService,
    },
  },
  {
    path: "auth",
    loadChildren: () =>
      import("./pages/auth/forgot-password/forgot-password.module").then(
        (m) => m.ForgotPasswordPageModule
      ),
    children: [
      {
        path: "forgot-password",
        loadChildren: () =>
          import("./pages/auth/forgot-password/forgot-password.module").then(
            (m) => m.ForgotPasswordPageModule
          ),
      },
      {
        path: "login",
        loadChildren: () =>
          import("./pages/auth/login/login.module").then(
            (m) => m.LoginPageModule
          ),
      },
      {
        path: "register",
        loadChildren: () =>
          import("./pages/auth/register/register.module").then(
            (m) => m.RegisterPageModule
          ),
      },
      {
        path: "reset-password",
        loadChildren: () =>
          import("./pages/auth/reset-password/reset-password.module").then(
            (m) => m.ResetPasswordPageModule
          ),
      },
    ],
  },
  {
    path: "blogs",
    loadChildren: () =>
      import("./pages/blog-listing/blog-listing.module").then(
        (m) => m.BlogListingPageModule
      ),
    resolve: {
      data: BlogListingDataService,
    },
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/blog-listing/blog-listing.module").then(
            (m) => m.BlogListingPageModule
          ),
        resolve: {
          data: BlogListingDataService,
        },
      },
      {
        path: "category/:categorySlug",
        loadChildren: () =>
          import("./pages/blog-listing/blog-listing.module").then(
            (m) => m.BlogListingPageModule
          ),
        resolve: {
          data: BlogListingDataService,
        },
      },
      {
        path: "tag/:tagSlug",
        loadChildren: () =>
          import("./pages/blog-listing/blog-listing.module").then(
            (m) => m.BlogListingPageModule
          ),
        resolve: {
          data: BlogListingDataService,
        },
      },
    ],
  },
  {
    path: "blog/:slug",
    loadChildren: () =>
      import("./pages/blog-detail/blog-detail.module").then(
        (m) => m.BlogDetailPageModule
      ),
    resolve: {
      data: BlogDetailDataService,
    },
  },
  {
    path: "competitions",
    loadChildren: () =>
      import("./pages/competitions-listing/competitions-listing.module").then(
        (m) => m.CompetitionsListingPageModule
      ),
    resolve: {
      data: CompetitionsListingDataService,
    },
  },
  {
    path: "competition/:slug",
    loadChildren: () =>
      import("./pages/competition-detail/competition-detail.module").then(
        (m) => m.CompetitionDetailPageModule
      ),
    resolve: {
      data: CompetitionDetailDataService,
    },
  },
  {
    path: "contact",
    loadChildren: () =>
      import("./pages/contact/contact.module").then((m) => m.ContactPageModule),
  },
  {
    path: "events",
    loadChildren: () =>
      import("./pages/events-listing/events-listing.module").then(
        (m) => m.EventsListingPageModule
      ),
    resolve: {
      data: EventsListingDataService,
    },
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/events-listing/events-listing.module").then(
            (m) => m.EventsListingPageModule
          ),
        resolve: {
          data: EventsListingDataService,
        },
      },
      {
        path: "category/:categorySlug",
        loadChildren: () =>
          import("./pages/events-listing/events-listing.module").then(
            (m) => m.EventsListingPageModule
          ),
        resolve: {
          data: EventsListingDataService,
        },
      },
    ],
  },
  {
    path: "event/:slug",
    loadChildren: () =>
      import("./pages/events-detail/events-detail.module").then(
        (m) => m.EventsDetailPageModule
      ),
    resolve: {
      data: EventsDetailDataService,
    },
  },
  {
    path: "movies",
    loadChildren: () =>
      import("./pages/movies-listing/movies-listing.module").then(
        (m) => m.MoviesListingPageModule
      ),
    resolve: {
      data: MoviesListingDataService,
    },
  },
  {
    path: "movie/:slug",
    loadChildren: () =>
      import("./pages/movie-detail/movie-detail.module").then(
        (m) => m.MovieDetailPageModule
      ),
    resolve: {
      data: MovieDetailDataService,
    },
  },
  {
    path: "offers",
    loadChildren: () =>
      import("./pages/offers-listing/offers-listing.module").then(
        (m) => m.OffersListingPageModule
      ),
    resolve: {
      data: OffersListingDataService,
    },
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/offers-listing/offers-listing.module").then(
            (m) => m.OffersListingPageModule
          ),
        resolve: {
          data: OffersListingDataService,
        },
      },
      {
        path: "category/:categorySlug",
        loadChildren: () =>
          import("./pages/offers-listing/offers-listing.module").then(
            (m) => m.OffersListingPageModule
          ),
        resolve: {
          data: OffersListingDataService,
        },
      },
      {
        path: ":slug",
        loadChildren: () =>
          import("./pages/offers-detail/offers-detail.module").then(
            (m) => m.OffersDetailPageModule
          ),
        resolve: {
          data: OffersDetailDataService,
        },
      },
    ],
  },
  {
    path: "page/:slug",
    loadChildren: () =>
      import("./pages/page-detail/page-detail.module").then(
        (m) => m.PageDetailPageModule
      ),
    resolve: {
      data: PageDetailDataService,
    },
  },
  {
    path: "profile",
    loadChildren: () =>
      import("./pages/auth/profile/profile.module").then(
        (m) => m.ProfilePageModule
      ),
    resolve: {
      data: ProfileDataService,
    },
  },
  {
    path: "shops",
    loadChildren: () =>
      import("./pages/stores-listing/stores-listing.module").then(
        (m) => m.StoresListingPageModule
      ),
    resolve: {
      data: StoresListingDataService,
    },
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/stores-listing/stores-listing.module").then(
            (m) => m.StoresListingPageModule
          ),
        resolve: {
          data: StoresListingDataService,
        },
      },
      {
        path: ":categorySlug",
        loadChildren: () =>
          import("./pages/stores-listing/stores-listing.module").then(
            (m) => m.StoresListingPageModule
          ),
        resolve: {
          data: StoresListingDataService,
        },
      },
      {
        path: ":startsWith",
        loadChildren: () =>
          import("./pages/stores-listing/stores-listing.module").then(
            (m) => m.StoresListingPageModule
          ),
        resolve: {
          data: StoresListingDataService,
        },
      },
      {
        path: ":categorySlug/:startsWith",
        loadChildren: () =>
          import("./pages/stores-listing/stores-listing.module").then(
            (m) => m.StoresListingPageModule
          ),
        resolve: {
          data: StoresListingDataService,
        },
      },
    ],
  },
  {
    path: "shop/:slug",
    loadChildren: () =>
      import("./pages/store-detail/store-detail.module").then(
        (m) => m.StoreDetailPageModule
      ),
    resolve: {
      data: StoreDetailDataService,
    },
  },
  {
    path: "mall-map",
    canActivate: [MallMapsGuard],
    loadChildren: () =>
      import("./pages/mall-map/mall-map.module").then(
        (m) => m.MallMapPageModule
      ),
  },
  {
    path: "sitemap",
    loadChildren: () =>
      import("./pages/sitemap/sitemap.module").then((m) => m.SitemapPageModule),
  },
  {
    path: "error-404",
    loadChildren: () =>
      import("./pages/error/error.module").then((m) => m.ErrorPageModule),
  },
  { path: "**", redirectTo: "/error-404" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(APP_ROUTES, {
      preloadingStrategy: PreloadAllModules,
      initialNavigation: "disabled",
      scrollPositionRestoration: "top",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
